import _isEqual from 'lodash.isequal';
import _sortBy from 'lodash.sortby';

type FilingNote = {
  readonly id?: number;
  readonly [unknown: string]: unknown;
};
type FilingNoteList = Array<FilingNote>;

export const arraysEqual = (arr1: FilingNoteList, arr2: FilingNoteList): boolean => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  arr1 = _sortBy<FilingNote>(arr1, ['id']);
  arr2 = _sortBy<FilingNote>(arr2, ['id']);

  let areEqual = true;
  for (let i = 0; i < arr1.length; i++) {
    if (!_isEqual(arr1[i], arr2[i])) {
      areEqual = false;
      break;
    }
  }

  return areEqual;
};

export const isArraysEqual = (arrayOne: Array<unknown>, arrayTwo: Array<unknown>): boolean =>
  JSON.stringify(arrayOne) === JSON.stringify(arrayTwo);

type DataObject = {
  [unknown: string | number]: string | number;
};
type DataObjectList = Array<DataObject>;

export const removeDuplicates = (
  arr: DataObjectList,
  identifier?: string | number
): DataObjectList =>
  arr.reduce<DataObjectList>(
    (unique, item) =>
      identifier && unique.findIndex(({ id }: DataObject) => id === item[identifier]) > -1
        ? unique
        : [...unique, item],
    []
  );
